import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, Navigate, useNavigate } from 'react-router-dom';
import './App.css'; // We can keep or modify this for basic styling

// Import components
import WelcomePage from './components/WelcomePage';
import LoginPage from './components/LoginPage';
import RegisterPage from './components/RegisterPage';
import HomePage from './components/HomePage';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUserEmail, setCurrentUserEmail] = useState(null);
  const navigate = useNavigate();

  // Check for token on initial load
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const email = localStorage.getItem('userEmail');
    if (token) {
      setIsAuthenticated(true);
      setCurrentUserEmail(email);
    }
  }, []);

  const handleLogin = (email) => {
    setIsAuthenticated(true);
    setCurrentUserEmail(email);
    // Token is already set in localStorage by LoginPage
    navigate('/home');
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userEmail');
    setIsAuthenticated(false);
    setCurrentUserEmail(null);
    navigate('/login');
  };

  return (
    <div className="App">
      <header className="App-header">
        <nav style={{ padding: '10px', backgroundColor: '#f0f0f0', marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <Link to="/" style={{ marginRight: '10px' }}>Welcome</Link>
            {isAuthenticated && <Link to="/home" style={{ marginRight: '10px' }}>Home</Link>}
          </div>
          <div>
            {!isAuthenticated ? (
              <>
                <Link to="/login" style={{ marginRight: '10px' }}>Login</Link>
                <Link to="/register" style={{ marginRight: '10px' }}>Register</Link>
              </>
            ) : (
              <>
                <span style={{ marginRight: '10px' }}>Welcome, {currentUserEmail}!</span>
                <button onClick={handleLogout}>Logout</button>
              </>
            )}
          </div>
        </nav>
      </header>

      <main>
        <Routes>
          <Route path="/" element={<WelcomePage />} />
          <Route path="/login" element={!isAuthenticated ? <LoginPage onLoginSuccess={handleLogin} /> : <Navigate to="/home" />} />
          <Route path="/register" element={!isAuthenticated ? <RegisterPage /> : <Navigate to="/home" />} />
          <Route 
            path="/home" 
            element={
              isAuthenticated ? (
                <HomePage userEmail={currentUserEmail} onLogout={handleLogout} />
              ) : (
                <Navigate to="/login" replace />
              )
            } 
          />
          {/* Catch-all route for unknown paths, could redirect to WelcomePage or a 404 component */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
